module.exports = "/_next/static/images/StartWithStrategy@2x-f168b5d71de93786ba2b35577a9aec40.webp";